/* nutrigoods – Verhalten und Animationen des Themes */
(() => {
  const T = window.theme || { routes: {}, strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const anim = document.documentElement.classList.contains('anim') && !reduce;
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const easeIO = t => (t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const root = () => (T.routes.root || '/').replace(/\/$/, '');
  const store = {
    get(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* Speicher nicht verfügbar */ } }
  };
  const smooth = () => (reduce ? 'auto' : 'smooth');
  const sz = (u, w) => { if (!u) return ''; try { const url = new URL(u, location.href); url.searchParams.set('width', w); return url.href; } catch (e) { return u; } };

  /* ---------- Geld ---------- */
  function money(cents) {
    const fmt = T.moneyFormat || '{{amount_with_comma_separator}} €';
    const n = Number(cents || 0) / 100;
    const fix = (d, th, dec) => { const p = n.toFixed(d).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? dec + p[1] : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: fix(2, ',', '.'), amount_no_decimals: fix(0, ',', '.'), amount_with_comma_separator: fix(2, '.', ','),
      amount_no_decimals_with_comma_separator: fix(0, '.', ','), amount_with_apostrophe_separator: fix(2, "'", '.')
    }[k] || fix(2, '.', ',')));
  }

  /* ---------- Ebenen: Schublade, Dialoge, Suche, Menü ---------- */
  const Overlay = {
    open(el, focusSel) {
      if (typeof el === 'string') el = document.getElementById(el);
      if (!el) return;
      this.closeAll(true);
      this.last = document.activeElement;
      el.classList.add('open'); el.setAttribute('aria-hidden', 'false');
      if (!el.classList.contains('menu')) $('#scrim')?.classList.add('open');
      document.documentElement.style.overflow = el.classList.contains('dialog') || el.classList.contains('menu') ? 'hidden' : '';
      setTimeout(() => (focusSel ? $(focusSel, el) : $('input, button, a', el))?.focus(), 40);
    },
    closeAll(keepFocus) {
      $$('.drawer.open, .dialog.open, .palette.open, .menu.open').forEach(el => { el.classList.remove('open'); el.setAttribute('aria-hidden', 'true'); });
      $('#scrim')?.classList.remove('open');
      document.documentElement.style.overflow = '';
      if (!keepFocus) this.last?.focus?.();
    },
    isOpen() { return !!$('.drawer.open, .dialog.open, .palette.open, .menu.open'); }
  };
  window.ngOverlay = Overlay;
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); Overlay.open(opener.dataset.open, opener.dataset.focus); return; }
    if (e.target.closest('[data-close]') || e.target.id === 'scrim' || (e.target.classList.contains('dialog') && e.target.classList.contains('open')) || (e.target.classList.contains('palette'))) Overlay.closeAll();
  });

  /* ---------- Hinweis (Toast) ---------- */
  let toastTimer;
  function toast(text, withLink = true) {
    const el = $('#toast'); if (!el) return;
    $('[data-toast-text]', el).textContent = text;
    const link = $('[data-toast-link]', el); if (link) link.hidden = !withLink;
    el.classList.add('show'); clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('show'), 3600);
  }

  /* ---------- Einblenden beim Scrollen ---------- */
  const revealer = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); revealer.unobserve(e.target); }
  }), { rootMargin: '0px 0px -8% 0px' }) : null;
  function reveal(scope = document) {
    $$('[data-reveal]:not(.in)', scope).forEach(el => (revealer ? revealer.observe(el) : el.classList.add('in')));
  }
  reveal();
  addEventListener('load', () => setTimeout(() => $$('[data-reveal]:not(.in)').forEach(el => {
    const r = el.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) el.classList.add('in');
  }), 2500));

  /* ---------- Ankündigung ---------- */
  $$('.notice').forEach(n => {
    let list = []; try { list = JSON.parse($('script[data-messages]', n).textContent); } catch (e) { return; }
    const line = $('.notice__line', n), ghost = $('.notice__ghost', n), typed = $('.notice__typed', n);
    if (!line || !list.length) return;
    const hold = (Number(n.dataset.hold) || 3) * 1000, wait = ms => new Promise(r => setTimeout(r, ms));
    let k = 0;
    const set = m => {
      ghost.textContent = m.text; line.setAttribute('aria-label', m.text);
      if (m.link) line.setAttribute('href', m.link); else line.removeAttribute('href');
    };
    // Überblenden (oder weniger Bewegung gewünscht)
    if (n.dataset.style !== 'type' || !anim) {
      if (list.length < 2) return;
      setInterval(() => {
        if (document.hidden) return;
        k = (k + 1) % list.length; line.classList.add('swap');
        setTimeout(() => { set(list[k]); typed.textContent = list[k].text; line.classList.remove('swap'); }, 260);
      }, hold + 1500);
      return;
    }
    // Schreibmaschine: tippen, stehen lassen, rückwärts löschen, nächster Hinweis
    const type = async m => {
      set(m); n.classList.add('is-typing');
      for (let i = 1; i <= m.text.length; i++) { typed.textContent = m.text.slice(0, i); await wait(32 + Math.random() * 38); }
      n.classList.remove('is-typing');
    };
    const erase = async () => {
      n.classList.add('is-typing');
      for (let t = typed.textContent; t.length; t = t.slice(0, -1)) { typed.textContent = t.slice(0, -1); await wait(14); }
      await wait(280);
    };
    (async () => {
      typed.textContent = '';
      await wait(500);
      await type(list[0]);
      if (list.length < 2) return;
      for (;;) {
        await wait(hold);
        while (document.hidden) await wait(600);
        await erase();
        k = (k + 1) % list.length;
        await type(list[k]);
      }
    })();
  });

  /* ---------- Kopfzeile über Farbflächen ---------- */
  const headerSection = $('.section-header');
  const overlayEl = $('.overlay-header');
  function headerScroll() {
    if (!headerSection || !overlayEl) return;
    const notice = $('.section-announcement')?.offsetHeight || 0;
    headerSection.classList.toggle('is-fixed', scrollY > notice);
    headerSection.classList.toggle('is-solid', overlayEl.getBoundingClientRect().bottom < (headerSection.offsetHeight || 64));
  }
  if (overlayEl) { addEventListener('scroll', () => requestAnimationFrame(headerScroll), { passive: true }); headerScroll(); }
  const setHead = v => document.documentElement.style.setProperty('--head', v);

  /* Menü passt nicht neben das mittige Logo: auf das Handy-Menü umschalten statt das Logo zu verschieben */
  function fitNav() {
    const nav = $('.section-header .nav'); if (!nav || !headerSection) return;
    headerSection.classList.remove('is-compact');
    if (getComputedStyle(nav).display === 'none') return;
    const items = $$('.nav__item', nav), last = items[items.length - 1];
    const need = last ? last.getBoundingClientRect().right - nav.getBoundingClientRect().left : 0;
    const logo = $('.section-header .top > .logo'), room = logo ? logo.getBoundingClientRect().left - nav.getBoundingClientRect().left - 24 : nav.clientWidth;
    headerSection.classList.toggle('is-compact', need > room);
  }
  fitNav(); addEventListener('resize', fitNav); document.fonts?.ready.then(fitNav);

  /* ---------- Warenkorb ---------- */
  const Cart = {
    sections() { return ['cart-drawer'].concat($('#main-cart-inner') ? [$('#main-cart-inner').dataset.section] : []).join(','); },
    async add(items, sourceImg) {
      const res = await fetch(`${T.routes.cartAdd}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: this.sections(), sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || T.strings.error);
      this.render(data.sections);
      const title = data.items?.[0]?.product_title || '';
      if (sourceImg && T.flyToCart && anim) await fly(sourceImg);
      bump();
      if (T.cartType === 'drawer' && $('#cart-drawer')) Overlay.open('cart-drawer', '[data-close]');
      else toast((T.strings.added || '').replace('[title]', title));
      document.dispatchEvent(new CustomEvent('ng:cart', { detail: data }));
      return data;
    },
    async change(key, quantity) {
      const res = await fetch(`${T.routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: this.sections(), sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok) { toast(data.description || T.strings.error, false); $$('[data-line].is-busy').forEach(l => l.classList.remove('is-busy')); return; }
      this.render(data.sections);
      bump();
    },
    render(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const targetSel = id === 'cart-drawer' ? '#cart-drawer-inner' : '#main-cart-inner';
        const fresh = $(targetSel, doc), old = $(targetSel);
        if (!fresh || !old) return;
        const oldP = $('.ship__bar i', old)?.style.getPropertyValue('--p');
        old.innerHTML = fresh.innerHTML;
        Object.assign(old.dataset, fresh.dataset);
        const bar = $('.ship__bar i', old);
        if (bar && oldP !== undefined && oldP !== '') { const np = bar.style.getPropertyValue('--p'); bar.style.setProperty('--p', oldP); requestAnimationFrame(() => requestAnimationFrame(() => bar.style.setProperty('--p', np))); }
        if (id === 'cart-drawer') $$('.cart-count').forEach(c => { c.dataset.n = fresh.dataset.count; const b = $('b', c); if (b) b.textContent = fresh.dataset.count; });
        reveal(old);
      });
    }
  };
  window.ngCart = Cart;
  function bump() { $$('.cart-count').forEach(c => { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); setTimeout(() => c.classList.remove('bump'), 320); }); }
  function fly(img) {
    const target = $('.section-header .cart-count')?.closest('.icon-btn') || $('[data-cart-icon]');
    if (!img || !target || !img.getBoundingClientRect) return Promise.resolve();
    const a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width) return Promise.resolve();
    const clone = document.createElement('img');
    clone.src = img.currentSrc || img.src; clone.className = 'fly';
    const size = Math.min(a.width, a.height, 220);
    Object.assign(clone.style, { left: `${a.left + a.width / 2 - size / 2}px`, top: `${a.top + a.height / 2 - size / 2}px`, width: `${size}px`, height: `${size}px` });
    document.body.append(clone);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const run = clone.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: `translate(${dx * .5}px, ${dy * .5 - 80}px) scale(.55)`, opacity: 1, offset: .55 },
      { transform: `translate(${dx}px, ${dy}px) scale(.08)`, opacity: .4 }
    ], { duration: 750, easing: 'cubic-bezier(.5,0,.3,1)' });
    return Promise.race([run.finished, new Promise(r => setTimeout(r, 900))]).then(() => clone.remove()).catch(() => clone.remove());
  }
  document.addEventListener('click', e => {
    const q = e.target.closest('[data-qty]');
    if (q) {
      const line = q.closest('[data-line]'); const input = $('input', line);
      const n = Math.max(0, Number(input.value) + Number(q.dataset.qty));
      line.classList.add('is-busy'); Cart.change(line.dataset.line, n);
    }
    const rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); const line = rm.closest('[data-line]'); line.classList.add('is-busy'); Cart.change(line.dataset.line, 0); }
  });
  document.addEventListener('change', e => {
    const input = e.target.closest('[data-line] input[type="number"]');
    if (input) { const line = input.closest('[data-line]'); line.classList.add('is-busy'); Cart.change(line.dataset.line, Math.max(0, Number(input.value) || 0)); }
  });
  $$('[data-cart-link]').forEach(a => a.addEventListener('click', e => {
    if (T.cartType === 'drawer' && $('#cart-drawer') && !document.body.classList.contains('template-cart')) { e.preventDefault(); Overlay.open('cart-drawer', '[data-close]'); }
  }));

  /* Produktformulare (Karte, Produktseite) */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = $('form', this); if (!this.form) return;
      this.form.addEventListener('submit', e => this.submit(e));
    }
    async submit(e) {
      e.preventDefault();
      const btn = $('[type="submit"]', this.form); if (btn?.disabled) return;
      const fd = new FormData(this.form);
      const id = Number(fd.get('id')); const quantity = Number(fd.get('quantity') || 1);
      btn?.classList.add('is-busy'); btn?.setAttribute('aria-busy', 'true');
      const img = this.closest('.pcard')?.querySelector('.pcard__img') || $(this.dataset.flyFrom || '') || null;
      try { await Cart.add([{ id, quantity }], img); }
      catch (err) { toast(err.message, false); }
      finally { btn?.classList.remove('is-busy'); btn?.removeAttribute('aria-busy'); }
    }
  }
  customElements.define('product-form', ProductForm);

  /* ---------- Suche (Strg/Cmd + K oder /) ---------- */
  const palette = $('#search-palette');
  if (palette) {
    const input = $('input[name="q"]', palette), list = $('[data-results]', palette), start = list.innerHTML;
    let timer, ctrl, sel = -1;
    const items = () => $$('.res, .palette__all', list);
    const mark = () => items().forEach((el, i) => el.setAttribute('aria-selected', i === sel));
    input.addEventListener('input', () => {
      clearTimeout(timer); sel = -1;
      const q = input.value.trim();
      if (!q) { list.innerHTML = start; return; }
      if (!T.predictiveSearch) return;
      timer = setTimeout(async () => {
        ctrl?.abort(); ctrl = new AbortController();
        try {
          const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,article,page,query&resources[limit]=6&resources[limit_scope]=each&section_id=predictive-search`;
          const html = await (await fetch(url, { signal: ctrl.signal })).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const res = $('#predictive-search-results', doc);
          list.innerHTML = res ? res.innerHTML : `<p class="palette__none">${T.strings.noResults || ''}</p>`;
        } catch (err) { /* abgebrochen */ }
      }, 180);
    });
    input.addEventListener('keydown', e => {
      const n = items().length;
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && n) { e.preventDefault(); sel = (sel + (e.key === 'ArrowDown' ? 1 : -1) + n) % n; mark(); items()[sel]?.scrollIntoView({ block: 'nearest' }); }
      if (e.key === 'Enter' && sel >= 0 && items()[sel]) { e.preventDefault(); items()[sel].click(); }
    });
  }
  addEventListener('keydown', e => {
    const typing = /INPUT|SELECT|TEXTAREA/.test(document.activeElement?.tagName || '') || document.activeElement?.isContentEditable;
    if (palette && ((e.key.toLowerCase() === 'k' && (e.metaKey || e.ctrlKey)) || (e.key === '/' && !typing))) { e.preventDefault(); Overlay.open(palette, 'input[name="q"]'); }
    if (e.key === 'Escape' && Overlay.isOpen()) Overlay.closeAll();
  });

  /* ---------- Weiche Seitenwechsel: Produktbild fliegt mit ---------- */
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href]'); if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const card = a.closest('.pcard, .mcard'); if (!card) return;
    const img = $('.js-pimg, .mcard__img img', card); if (img) img.style.viewTransitionName = 'pimg';
  });
  addEventListener('pageshow', () => $$('.js-pimg, .mcard__img img').forEach(i => { i.style.viewTransitionName = ''; }));

  /* ---------- Farbe und Ausschnitt aus dem Produktfoto ---------- */
  const hex = (r, g, b) => '#' + [r, g, b].map(v => Math.round(clamp(v, 0, 255)).toString(16).padStart(2, '0')).join('');
  function hsl2rgb(h, s, l) {
    const k = n => (n + h / 30) % 12, a = s * Math.min(l, 1 - l);
    const f = n => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [f(0) * 255, f(8) * 255, f(4) * 255];
  }
  function rgb2hsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    const mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2; let h = 0, s = 0;
    if (mx !== mn) {
      const d = mx - mn; s = l > .5 ? d / (2 - mx - mn) : d / (mx + mn);
      h = mx === r ? (g - b) / d + (g < b ? 6 : 0) : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; h *= 60;
    }
    return [h, s, l];
  }
  function palette2(r, g, b) {
    const [h, s, l] = rgb2hsl(r, g, b);
    if (s < .12) return l > .6 ? { tint: '#e4e3df', deep: '#2b2b2b' } : { tint: '#d9d9d6', deep: '#1b1b1b' };
    return { tint: hex(...hsl2rgb(h, Math.min(s, .5) * .85, .86)), deep: hex(...hsl2rgb(h, Math.min(s * 1.05, .62), .25)) };
  }
  function fromHex(c) { const m = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(c || ''); return m ? palette2(parseInt(m[1], 16), parseInt(m[2], 16), parseInt(m[3], 16)) : null; }
  const analyzeCache = {};
  function analyze(src) {
    if (!src) return Promise.resolve(null);
    const key = 'ng-an:' + src.split('?')[0];
    if (analyzeCache[key]) return analyzeCache[key];
    const cached = store.get(key); if (cached) return (analyzeCache[key] = Promise.resolve(cached));
    analyzeCache[key] = new Promise(resolve => {
      const im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async';
      im.onload = () => {
        try {
          const W = 120, H = Math.round(120 * (im.naturalHeight / im.naturalWidth || 1));
          const c = document.createElement('canvas'); c.width = W; c.height = H;
          const ctx = c.getContext('2d', { willReadFrequently: true }); ctx.drawImage(im, 0, 0, W, H);
          const d = ctx.getImageData(0, 0, W, H).data, px = (x, y) => { const i = (y * W + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; };
          const bg = px(1, 1), clear = bg[3] < 20;
          const solid = p => (clear ? p[3] > 128 : Math.abs(p[0] - bg[0]) + Math.abs(p[1] - bg[1]) + Math.abs(p[2] - bg[2]) > 40 && p[3] > 128);
          const rows = [];
          for (let y = 0; y < H; y++) { let l = -1, r = -1; for (let x = 0; x < W; x++) if (solid(px(x, y))) { if (l < 0) l = x; r = x; } if (r - l > 2) rows.push([y, l, r]); }
          if (rows.length < 8) return resolve(null);
          const t = rows[0][0], b = rows[rows.length - 1][0], mid = rows.filter(([y]) => y > t + (b - t) * .45 && y < t + (b - t) * .8);
          const L = Math.min(...mid.map(m => m[1])), R = Math.max(...mid.map(m => m[2]));
          let sr = 0, sg = 0, sb = 0, n = 0;
          mid.forEach(([y, l, r]) => { for (let x = l + 2; x < r - 1; x += 2) { const p = px(x, y); if (!solid(p)) continue; const mx = Math.max(p[0], p[1], p[2]); if (mx > 245) continue; sr += p[0]; sg += p[1]; sb += p[2]; n++; } });
          const out = { crop: [L / W, t / H, (R + 1) / W, (b + 1) / H], ...(n ? { ...palette2(sr / n, sg / n, sb / n), col: hex(sr / n, sg / n, sb / n) } : {}) };
          store.set(key, out); resolve(out);
        } catch (err) { resolve(null); }
      };
      im.onerror = () => resolve(null);
      im.src = sz(src, 120);
    });
    return analyzeCache[key];
  }

  /* ---------- Schwesterprodukt mit/ohne Deckel ---------- */
  const sibCache = {};
  let lidIndex = null; // Paare aus dem Hero (gleicher Kurzname), spart Abrufe
  function lidGroup(item) { return (lidIndex || []).filter(l => l.short === item.short && l.handle !== item.handle); }
  function fixLid(item) {
    // Zwei Produkte gleichen Namens ohne „mit Deckel“ im Titel: das teurere ist das mit Deckel
    if (item.lid !== 'ohne') return;
    const twin = lidGroup(item).find(l => !l.mit);
    if (twin && item.price > twin.price) item.lid = 'mit';
  }
  function lidCandidates(handle, hasLid) {
    if (hasLid) return [handle.replace('-mit-deckel', ''), handle.replace('-mit-deckel', '').replace(/-500-ml$/, '-500ml'), handle.replace(/-1$/, '')];
    return [handle.replace(/-(500-?ml)$/, '-mit-deckel-$1'), handle.replace(/-500ml$/, '-mit-deckel-500-ml'), handle + '-1'];
  }
  async function findSibling(item) {
    if (!item.lid) return null;
    if (sibCache[item.handle] !== undefined) return sibCache[item.handle];
    const hasLid = item.lid === 'mit';
    const local = lidGroup(item)[0];
    if (local) return (sibCache[item.handle] = { handle: local.handle, url: local.url, title: local.title, price: local.price, variant: local.variant, available: local.available, img: local.img, lid: hasLid ? 'ohne' : 'mit' });
    for (const h of [...new Set(lidCandidates(item.handle, hasLid))]) {
      if (!h || h === item.handle) continue;
      try {
        const r = await fetch(`${root()}/products/${h}.js`); if (!r.ok) continue;
        const p = await r.json();
        const otherHasLid = /mit deckel/i.test(p.title);
        if (otherHasLid === hasLid) continue;
        const v = p.variants.find(x => x.available) || p.variants[0];
        return (sibCache[item.handle] = { handle: p.handle, url: p.url, title: p.title, price: v.price, variant: v.id, available: v.available, img: (p.featured_image || '').replace(/^https?:/, ''), lid: otherHasLid ? 'mit' : 'ohne' });
      } catch (err) { /* nächster Versuch */ }
    }
    return (sibCache[item.handle] = null);
  }

  /* ---------- Hero: Kollektionen, Flaschenreihe, Zoom ---------- */
  class HeroCollections extends HTMLElement {
    connectedCallback() {
      try { this.data = JSON.parse($('script[data-hero]', this).textContent); } catch (e) { return; }
      if (this.data.lids?.length) { lidIndex = this.data.lids; this.data.collections.forEach(c => c.items.forEach(fixLid)); }
      this.stage = $('.lh-stage', this); this.row = $('.lh-row', this); this.intro = $('.lh-intro', this); this.nameEl = $('.lh-name', this);
      this.coll = 0; this.sel = 0; this.hover = -1; this.p = 0; this.lidState = {}; this.BW = 180; this.BH = 600;
      this.tabs = $$('.lh-tabs [role="tab"]', this);
      this.tabs.forEach((b, i) => b.addEventListener('click', () => this.setColl(i)));
      $('.lh-tabs', this)?.addEventListener('keydown', e => { const d = { ArrowRight: 1, ArrowLeft: -1 }[e.key]; if (!d) return; e.preventDefault(); const i = (this.coll + d + this.tabs.length) % this.tabs.length; this.setColl(i); this.tabs[i].focus(); });
      $('[data-prev]', this)?.addEventListener('click', () => this.choose(this.sel - 1));
      $('[data-next]', this)?.addEventListener('click', () => this.choose(this.sel + 1));
      $$('[data-back]', this).forEach(b => b.addEventListener('click', () => this.scrollToP(0)));
      $('[data-add]', this)?.addEventListener('click', () => this.add());
      $('[data-gallery-open]', this)?.addEventListener('click', () => this.gallery(0));
      let x0 = null;
      this.stage.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      this.stage.addEventListener('touchend', e => { if (x0 === null || this.p < .5) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) this.choose(this.sel + (dx < 0 ? 1 : -1)); x0 = null; });
      addEventListener('scroll', () => requestAnimationFrame(() => this.onScroll()), { passive: true });
      addEventListener('resize', () => { this.measure(); this.render(); });
      addEventListener('keydown', e => {
        const typing = /INPUT|SELECT|TEXTAREA/.test(document.activeElement?.tagName || '');
        const r = this.getBoundingClientRect();
        if (typing || Overlay.isOpen() || document.activeElement?.closest('.lh-tabs, .tabs') || r.top > 0 || r.bottom < innerHeight * .5) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); this.choose(this.sel + (e.key === 'ArrowRight' ? 1 : -1)); }
      });
      document.addEventListener('ng:pick', e => this.pick(e.detail));
      this.bindBottles(); this.measure(); this.details(); this.onScroll(); this.row.classList.add('ready');
      document.fonts?.ready.then(() => { this.measure(); this.render(); });
      requestAnimationFrame(() => setTimeout(() => this.row.classList.remove('pre'), 60));
      this.items.forEach((it, i) => this.refine(it, i));
    }
    get items() { return this.data.collections[this.coll]?.items || []; }
    get item() { return this.items[this.sel]; }
    get variantData() { const it = this.item, s = this.lidState[it.handle]; return s && s.useSibling && s.sib ? s.sib : it; }
    bindBottles() {
      $$('.lh-bottle', this.row).forEach((b, i) => {
        b.onclick = () => this.choose(i, true);
        b.onmouseenter = b.onfocus = () => { this.hover = i; this.mark(); };
        b.onmouseleave = b.onblur = () => { this.hover = -1; this.mark(); };
      });
    }
    bottleHTML(it, i) {
      const [l, t, r, b] = it.crop || this.data.crop, size = this.BH / (b - t), cx = (l + r) / 2;
      const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      return `<button class="lh-bottle" type="button" style="--i:${i}" aria-label="${esc(it.title)}, ${esc(money(it.price))}"><span class="lh-crop"><img src="${sz(it.img, 700)}" alt="" width="${Math.round(size)}" height="${Math.round(size)}" style="width:${size}px;height:${size}px;top:${-t * size + .02 * this.BH}px;left:${this.BW / 2 - cx * size + .06 * this.BW}px"></span></button>`;
    }
    place(img, crop) {
      const [l, t, r, b] = crop, size = this.BH / (b - t), cx = (l + r) / 2;
      Object.assign(img.style, { width: `${size}px`, height: `${size}px`, top: `${-t * size + .02 * this.BH}px`, left: `${this.BW / 2 - cx * size + .06 * this.BW}px` });
    }
    refine(it, i) {
      if (it.tint) { const c = fromHex(it.tint); if (c && !it.deep) it.deep = c.deep; }
      analyze(it.img).then(a => {
        if (!a) return;
        if (a.crop && !it.fixedCrop) { it.crop = a.crop; const img = this.row.children[i]?.querySelector('img'); if (img && this.items[i] === it) { this.place(img, a.crop); this.measure(); this.render(); } }
        if (!it.tint) { it.tint = a.tint; it.deep = a.deep; if (this.item === it) this.details(); }
      });
    }
    measure() {
      const W = innerWidth, H = this.stage.clientHeight, n = this.items.length, phone = W < 700;
      const rows = phone && n > 6 ? 2 : 1, per = Math.ceil(n / rows);
      const introBottom = this.intro.offsetTop + this.intro.offsetHeight;
      const floor = H - (phone ? 4.5 : 5.5) * 16;
      const availH = (floor - introBottom - (phone ? 16 : 40)) / rows - (rows > 1 ? 28 : 0);
      const gap = .07, ratio = .3;
      const h = Math.max(80, Math.min(availH, phone ? H * .4 : H * .6, (W - 2 * (phone ? 16 : 40)) / (per * ratio + (per - 1) * gap)));
      const w = h * ratio, block = rows * h + (rows - 1) * 28, top0 = introBottom + Math.max(phone ? 16 : 40, (floor - introBottom - block) / 2);
      const nameBottom = this.nameEl.offsetTop + this.nameEl.offsetHeight;
      const fFloor = H - (phone ? 8.75 : 6.5) * 16, fH = Math.max(160, fFloor - nameBottom - 12);
      this.layout = this.items.map((_, i) => {
        const r = Math.floor(i / per), k = i - r * per, inRow = Math.min(per, n - r * per), rw = inRow * w + (inRow - 1) * h * gap;
        return { cx: (W - rw) / 2 + k * (w + h * gap) + w / 2, bottom: top0 + h + r * (h + 28), h, r };
      });
      Object.assign(this.layout, { focus: { cx: W / 2, bottom: fFloor, h: fH, W }, rows, blockBottom: top0 + block });
    }
    onScroll() {
      const r = this.getBoundingClientRect(), range = this.offsetHeight - innerHeight;
      this.p = range > 0 ? clamp(-r.top / range) : 0; this.render();
    }
    render() {
      if (!this.layout) return;
      const t = easeIO(clamp((this.p - .06) / .5)), st = this.stage.style;
      const fo = clamp((t - .55) * 2.4), io = 1 - clamp(t * 2.2), bo = clamp((this.p - .5) / .14);
      st.setProperty('--t', t.toFixed(3)); st.setProperty('--intro', io.toFixed(3)); st.setProperty('--fo', fo.toFixed(3));
      st.setProperty('--p0', clamp(this.p * 12).toFixed(3)); st.setProperty('--bo', bo.toFixed(3));
      this.nameEl.style.visibility = fo < .02 ? 'hidden' : 'visible';
      this.intro.style.visibility = io < .02 ? 'hidden' : 'visible';
      $$('.buy, .lh-back, .lh-info, .lh-spec', this).forEach(el => el.classList.toggle('on', bo > .02));
      this.row.classList.toggle('lineup', t < .05);
      setHead(t > .5 ? 'var(--deep)' : 'var(--ink)');
      const f = this.layout.focus, s0 = this.layout[this.sel];
      $$('.lh-bottle', this.row).forEach((b, i) => {
        const L = this.layout[i]; if (!L) return;
        let cx, bottom, h, op = 1;
        if (i === this.sel) { cx = lerp(L.cx, f.cx, t); bottom = lerp(L.bottom, f.bottom, t); h = lerp(L.h, f.h, t); }
        else { const fx = f.cx + (L.cx - s0.cx) * (f.h / s0.h) * 1.15; cx = lerp(L.cx, fx, t); bottom = lerp(L.bottom, f.bottom, t); h = lerp(L.h, f.h * .92, t); op = 1 - clamp(t * (L.r === s0.r ? 1.4 : 4)); }
        const sc = h / this.BH;
        b.style.transform = `translate(${(cx - this.BW * sc / 2).toFixed(1)}px, ${(bottom - h).toFixed(1)}px) scale(${sc.toFixed(4)})`;
        b.style.opacity = op.toFixed(3); b.style.zIndex = i === this.sel ? 2 : 1;
        b.tabIndex = t > .5 && i !== this.sel ? -1 : 0; b.setAttribute('aria-pressed', i === this.sel);
      });
      this.mark();
    }
    mark() {
      const i = this.hover >= 0 ? this.hover : this.sel, it = this.items[i], L = this.layout?.[i]; if (!it || !L) return;
      const m = $('.lh-mark', this); if (!m) return;
      $('b', m).textContent = it.short; $('span', m).textContent = money(it.price);
      const two = this.layout.rows > 1;
      m.style.left = `${two ? this.layout.focus.W / 2 : L.cx}px`; m.style.top = `${(two ? this.layout.blockBottom : L.bottom) + 10}px`;
    }
    details() {
      const it = this.item; if (!it) return;
      const v = this.variantData, docEl = document.documentElement.style;
      const tint = it.tint || this.data.tint, deep = it.deep || this.data.deep;
      this.style.setProperty('--tint', tint); this.style.setProperty('--deep', deep);
      docEl.setProperty('--tint', tint); docEl.setProperty('--deep', deep);
      this.nameEl.textContent = it.short; this.nameEl.style.setProperty('--len', Math.max(7, it.short.length));
      const set = (sel, txt) => { const el = $(sel, this); if (el) el.textContent = txt; };
      set('[data-buy-name]', it.title); set('[data-buy-sub]', this.data.collections[this.coll].sub || '');
      set('[data-price]', money(v.price)); set('[data-price2]', money(v.price));
      set('[data-var]', it.lid ? (this.lidState[it.handle]?.useSibling ? this.lidLabel(this.lidState[it.handle].sib.lid) : this.lidLabel(it.lid)) : '');
      const add = $('[data-add]', this); if (add) { add.disabled = !v.available; $('span', add).textContent = v.available ? T.strings.addToCart : T.strings.soldOut; }
      const coll = this.data.collections[this.coll];
      set('[data-desc]', coll.desc || it.desc || ''); set('[data-dim]', coll.dim || ''); set('[data-spec]', coll.spec || '');
      const sizeBtn = $('[data-size-btn]', this); if (sizeBtn) sizeBtn.hidden = !coll.sizeDialog;
      const dimRow = $('.lh-spec b', this); if (dimRow) dimRow.hidden = !coll.dim;
      this.renderOpts();
      document.dispatchEvent(new CustomEvent('ng:select', { detail: { item: it, img: v.img || it.img } }));
    }
    lidLabel(l) { return l === 'mit' ? this.data.labels.lid : this.data.labels.noLid; }
    async renderOpts() {
      const box = $('.buy__opts', this); if (!box) return;
      const it = this.item, label = s => `<button type="button" aria-pressed="${s.on}" ${s.dis ? 'disabled' : ''} data-lid="${s.v}">${s.t}</button>`;
      if (!it.lid) { box.innerHTML = it.size ? `<button type="button" aria-pressed="true" disabled>${it.size}</button>` : ''; return; }
      const st = this.lidState[it.handle] || (this.lidState[it.handle] = {});
      const own = it.lid;
      box.innerHTML = label({ v: own, t: this.lidLabel(own), on: !st.useSibling }) + `<button type="button" aria-pressed="false" disabled>…</button>`;
      const sib = st.sib !== undefined ? st.sib : (st.sib = await findSibling(it));
      if (this.item !== it) return;
      const parts = [{ v: own, t: this.lidLabel(own), on: !st.useSibling, p: it.price }];
      if (sib) parts.push({ v: sib.lid, t: this.lidLabel(sib.lid), on: !!st.useSibling, p: sib.price });
      parts.sort((a, b) => (a.v === 'mit' ? -1 : 1));
      box.innerHTML = parts.map(label).join('');
      $$('button[data-lid]', box).forEach(b => b.addEventListener('click', () => {
        st.useSibling = b.dataset.lid !== own; const img = this.row.children[this.sel]?.querySelector('img');
        if (img) img.src = sz(this.variantData.img || it.img, 700);
        this.details();
      }));
    }
    choose(i, zoom) {
      const n = this.items.length; if (!n) return;
      const prev = this.sel; this.sel = (i + n) % n;
      if (prev !== this.sel) { const st = this.lidState[this.items[prev].handle]; if (st?.useSibling) { st.useSibling = false; const img = this.row.children[prev]?.querySelector('img'); if (img) img.src = sz(this.items[prev].img, 700); } }
      this.details(); this.measure();
      if (zoom && this.p < .5) { this.scrollToP(.64); return; }
      this.row.classList.add('tween'); this.render(); setTimeout(() => this.row.classList.remove('tween'), 700);
    }
    has(handle) { return this.data.collections.some(c => c.items.some(x => x.handle === handle)); }
    pick(detail) {
      const ci = this.data.collections.findIndex(c => c.items.some(x => x.handle === detail.handle));
      if (ci < 0) return;
      const go = () => { const i = this.items.findIndex(x => x.handle === detail.handle); this.choose(i); this.scrollToP(.64); };
      if (ci !== this.coll) { this.setColl(ci, true); go(); } else go();
    }
    scrollToP(target) { scrollTo({ top: this.offsetTop + (this.offsetHeight - innerHeight) * target, behavior: smooth() }); }
    setColl(i, instant) {
      if (i === this.coll || !this.data.collections[i]) return;
      this.tabs.forEach((b, j) => { b.setAttribute('aria-selected', j === i); b.tabIndex = j === i ? 0 : -1; });
      const title = $('.lh-title', this), sub = $('.lh-sub', this);
      const apply = () => {
        this.coll = i; this.sel = 0; this.hover = -1;
        const c = this.data.collections[i];
        title.textContent = c.title; title.classList.remove('swap');
        if (sub) sub.textContent = c.subline;
        this.row.classList.remove('out'); this.row.classList.add('pre');
        this.row.innerHTML = c.items.map((it, k) => this.bottleHTML(it, k)).join('');
        this.bindBottles(); this.measure(); this.details(); this.render();
        c.items.forEach((it, k) => this.refine(it, k));
        requestAnimationFrame(() => requestAnimationFrame(() => this.row.classList.remove('pre')));
      };
      if (instant || reduce) return apply();
      this.row.classList.add('out'); title.classList.add('swap');
      setTimeout(apply, 380 + this.items.length * 20);
    }
    async add() {
      const v = this.variantData; if (!v.variant) return;
      const btn = $('[data-add]', this); btn.classList.add('is-busy');
      try { await Cart.add([{ id: v.variant, quantity: 1 }], this.row.children[this.sel]?.querySelector('img')); }
      catch (err) { toast(err.message, false); }
      finally { btn.classList.remove('is-busy'); }
    }
    gallery(k) {
      const it = this.item, list = (this.variantData.imgs || it.imgs || [it.img]);
      openGallery(list.map(src => ({ src, cap: it.title })), k);
    }
  }
  customElements.define('hero-collections', HeroCollections);

  /* ---------- Galerie-Dialog ---------- */
  let gal = { list: [], i: 0 };
  function openGallery(list, i = 0) {
    const d = $('#gallery-dialog'); if (!d || !list.length) return;
    gal = { list, i };
    const show = k => {
      gal.i = (k + gal.list.length) % gal.list.length; const g = gal.list[gal.i];
      const img = $('[data-gallery-img]', d); img.src = sz(g.src, 1400); img.alt = g.cap || '';
      $('[data-gallery-count]', d).textContent = `${gal.i + 1}/${gal.list.length}`; $('[data-gallery-cap]', d).textContent = g.cap || '';
    };
    d.ngShow = show; show(i); Overlay.open(d, '[data-close]');
  }
  window.ngGallery = openGallery;
  document.addEventListener('click', e => {
    const d = $('#gallery-dialog'); if (!d || !d.ngShow) return;
    if (e.target.closest('[data-gallery-prev]')) d.ngShow(gal.i - 1);
    if (e.target.closest('[data-gallery-next]')) d.ngShow(gal.i + 1);
  });
  addEventListener('keydown', e => {
    const d = $('#gallery-dialog'); if (!d?.classList.contains('open')) return;
    if (e.key === 'ArrowRight') d.ngShow(gal.i + 1); if (e.key === 'ArrowLeft') d.ngShow(gal.i - 1);
  });

  /* ---------- Aussage Wort für Wort ---------- */
  const initWords = (scope = document) => $$('[data-words]:not(.is-split)', scope).forEach(p => {
    if (!anim) return;
    p.classList.add('is-split');
    p.innerHTML = p.textContent.trim().split(/\s+/).map(w => `<span class="w">${w.replace(/</g, '&lt;')}</span>`).join(' ');
    const ws = $$('.w', p);
    const run = () => { const r = p.getBoundingClientRect(), vh = innerHeight; const t = clamp((vh * .85 - r.top) / (r.height + vh * .35)); const n = Math.round(t * ws.length); ws.forEach((w, i) => w.classList.toggle('on', i < n)); };
    addEventListener('scroll', () => requestAnimationFrame(run), { passive: true }); run();
  });
  initWords();

  /* ---------- Theme-Editor: neu geladene Sections wieder beleben ---------- */
  document.addEventListener('shopify:section:load', e => { reveal(e.target); initWords(e.target); });
  document.addEventListener('shopify:block:select', e => { const d = e.target.closest('details'); if (d) d.open = true; e.target.classList?.add('in'); });

  /* ---------- Zeichnung wird zur Flasche ---------- */
  class DrawScroll extends HTMLElement {
    connectedCallback() {
      this.box = $('.draw__box', this); this.spots = $$('.spot', this); this.img = $('.draw__box > img', this);
      const set = p => {
        const draw = clamp(p / .38), photo = clamp((p - .36) / .2);
        this.box.style.setProperty('--dash', (1 - draw).toFixed(3)); this.box.style.setProperty('--photo', photo.toFixed(3));
        this.spots.forEach((s, i) => s.classList.toggle('show', p > .58 + i * .06));
      };
      const run = () => {
        if (!anim) return set(1);
        const r = this.getBoundingClientRect();
        if (innerWidth < 700) return set(clamp((innerHeight * .9 - r.top) / (innerHeight * 1.1)));
        set(clamp(-r.top / (this.offsetHeight - innerHeight)));
      };
      addEventListener('scroll', () => requestAnimationFrame(run), { passive: true }); addEventListener('resize', run); run();
      this.spots.forEach(s => $('button', s).addEventListener('click', () => {
        const o = !s.classList.contains('open');
        this.spots.forEach(x => { x.classList.remove('open'); $('button', x).setAttribute('aria-expanded', 'false'); });
        s.classList.toggle('open', o); $('button', s).setAttribute('aria-expanded', o);
      }));
      document.addEventListener('ng:select', e => {
        const it = e.detail.item; if (!this.img || !this.dataset.vendor || (it.vendor || '').toLowerCase() !== this.dataset.vendor.toLowerCase()) return;
        this.img.removeAttribute('srcset'); this.img.src = sz(e.detail.img, 1400);
      });
    }
  }
  customElements.define('draw-scroll', DrawScroll);

  /* ---------- Technik-Reiter ---------- */
  class TechTabs extends HTMLElement {
    connectedCallback() {
      const tabs = $$('[role="tab"]', this), art = $('.xs', this);
      const sel = b => {
        tabs.forEach(t => { const on = t === b; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; const panel = document.getElementById(t.getAttribute('aria-controls')); if (panel) panel.hidden = !on; });
        if (art) art.dataset.s = b.dataset.s;
      };
      const cur = tabs.find(t => t.getAttribute('aria-selected') === 'true') || tabs[0];
      if (cur && art) art.dataset.s = cur.dataset.s;
      tabs.forEach(t => t.addEventListener('click', () => sel(t)));
      $('[role="tablist"]', this)?.addEventListener('keydown', e => { const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key]; if (!d) return; e.preventDefault(); const i = (tabs.findIndex(t => t.getAttribute('aria-selected') === 'true') + d + tabs.length) % tabs.length; sel(tabs[i]); tabs[i].focus(); });
    }
  }
  customElements.define('tech-tabs', TechTabs);

  /* ---------- Modell-Karussell ---------- */
  class ModelCarousel extends HTMLElement {
    connectedCallback() {
      const track = $('.track', this);
      $$('[data-dot][data-auto]', this).forEach(d => analyze(d.dataset.img).then(c => { if (c?.col) d.style.setProperty('--c', c.col); }));
      const step = d => track.scrollBy({ left: d * (($('.mcard', track)?.offsetWidth || 300) + 16), behavior: smooth() });
      $('[data-prev]', this)?.addEventListener('click', () => step(-1)); $('[data-next]', this)?.addEventListener('click', () => step(1));
      this.addEventListener('click', async e => {
        const card = e.target.closest('.mcard'); if (!card) return;
        const dot = e.target.closest('[data-dot]');
        if (dot) {
          $$('[data-dot]', card).forEach(b => b.setAttribute('aria-pressed', b === dot));
          const im = $('.mcard__img img', card);
          im.style.opacity = 0; setTimeout(() => { im.src = dot.dataset.img; im.removeAttribute('srcset'); im.alt = dot.dataset.title; im.onload = () => { im.style.opacity = 1; }; }, 150);
          Object.assign(card.dataset, { url: dot.dataset.url, variant: dot.dataset.variant, handle: dot.dataset.handle, available: dot.dataset.available });
          $('.mcard__img', card).href = dot.dataset.url;
          return;
        }
        const buy = e.target.closest('[data-buy]'); if (!buy) return;
        e.preventDefault();
        const mode = buy.dataset.buy;
        const hero = $('hero-collections');
        if (mode === 'hero' && hero?.has?.(card.dataset.handle)) { hero.pick({ handle: card.dataset.handle }); return; }
        if (mode === 'cart' && card.dataset.variant && card.dataset.available === 'true') {
          buy.classList.add('is-busy');
          try { await Cart.add([{ id: Number(card.dataset.variant), quantity: 1 }], $('.mcard__img img', card)); } catch (err) { toast(err.message, false); }
          buy.classList.remove('is-busy'); return;
        }
        location.href = card.dataset.url;
      });
    }
  }
  customElements.define('model-carousel', ModelCarousel);

  /* ---------- Größenvergleich: Milliliter oder Tassen ---------- */
  class SizeCompare extends HTMLElement {
    connectedCallback() {
      const sw = $('[role="switch"]', this); if (!sw) return;
      const cup = Number(this.dataset.cup || 250), unitCup = this.dataset.cupLabel || '';
      sw.addEventListener('click', () => {
        const on = sw.getAttribute('aria-checked') !== 'true'; sw.setAttribute('aria-checked', on);
        $$('[data-unit]', this).forEach((s, i) => s.classList.toggle('on', on ? i === 1 : i === 0));
        const f = ml => (ml / cup).toLocaleString(document.documentElement.lang || 'de', { maximumFractionDigits: 1 });
        $$('[data-ml]', this).forEach(td => {
          const [a, b] = td.dataset.ml.split('-').map(Number);
          if (!a) return;
          td.textContent = on ? (b ? `${f(a)} – ${f(b)} ${unitCup}` : `${f(a)} ${unitCup}`) : (b ? `${a} – ${b} ml` : `${a} ml`);
        });
      });
    }
  }
  customElements.define('size-compare', SizeCompare);

  /* ---------- Bereiche (Folien) ---------- */
  class SlideShow extends HTMLElement {
    connectedCallback() {
      const slides = $$('.slide', this), dots = $('.slides__dots', this); let si = 0;
      if (slides.length < 2) { slides[0]?.classList.add('on'); return; }
      slides.forEach((s, i) => { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', $('h2, h3', s)?.textContent || String(i + 1)); b.innerHTML = '<i></i>'; b.onclick = () => go(i); dots.append(b); });
      const go = i => {
        si = (i + slides.length) % slides.length;
        slides.forEach((s, j) => { s.classList.toggle('on', j === si); s.setAttribute('aria-hidden', j !== si); $$('a, button', s).forEach(a => { a.tabIndex = j === si ? 0 : -1; }); });
        $$('button', dots).forEach((b, j) => b.setAttribute('aria-current', j === si));
      };
      go(0);
      let x0 = null;
      this.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) go(si + (dx < 0 ? 1 : -1)); x0 = null; });
    }
  }
  customElements.define('slide-show', SlideShow);

  /* ---------- Produktseite ---------- */
  class ProductPage extends HTMLElement {
    connectedCallback() {
      try { this.data = JSON.parse($('script[data-product]', this).textContent); } catch (e) { return; }
      this.hero = $('.pp-hero', this); this.bar = $('.pp-buy', this); this.form = $('form', this.bar || this);
      this.selected = (this.data.current?.options || []).slice();
      $$('[data-option]', this).forEach(b => b.addEventListener('click', () => { this.selected[Number(b.dataset.index)] = b.dataset.option; this.update(); }));
      $('[data-swatch-toggle]', this)?.addEventListener('click', e => { const pop = $('.pp-swatches', this); const o = !pop.classList.contains('open'); pop.classList.toggle('open', o); e.currentTarget.setAttribute('aria-expanded', o); });
      document.addEventListener('click', e => { if (!e.target.closest('.pp-buy')) { $('.pp-swatches', this)?.classList.remove('open'); $('[data-swatch-toggle]', this)?.setAttribute('aria-expanded', 'false'); } });
      $$('[data-gallery-index]', this).forEach(b => b.addEventListener('click', () => openGallery(this.data.media.map(src => ({ src, cap: this.data.title })), Number(b.dataset.galleryIndex))));
      if (this.hero) {
        setHead('var(--deep)');
        const apply = c => { if (!c) return; this.style.setProperty('--tint', c.tint); this.style.setProperty('--deep', c.deep); document.documentElement.style.setProperty('--tint', c.tint); document.documentElement.style.setProperty('--deep', c.deep); };
        const own = fromHex(this.data.color); if (own) apply(own); else analyze(this.data.image).then(apply);
        const io = new IntersectionObserver(([e]) => setHead(e.isIntersecting ? 'var(--deep)' : 'var(--ink)'), { rootMargin: '-64px 0px 0px 0px' });
        io.observe(this.hero);
      }
      if (this.bar && this.form) {
        /* Apps hängen sich gern in das Kaufformular. In der schmalen Leiste stört das, darum ziehen sie in den Detailbereich um. */
        const slot = $('[data-app-slot]', this);
        const ours = el => el.nodeType !== 1 || el.matches('input, script, style, template, .buy__round, .buy__name, .buy__opts, .buy__add');
        const move = () => { if (!slot) return; [...this.form.children].filter(el => !ours(el)).forEach(el => { slot.append(el); slot.hidden = false; }); };
        move(); new MutationObserver(move).observe(this.form, { childList: true });
      }
      if (this.bar) {
        const foot = $('.section-footer');
        if (foot) new IntersectionObserver(([e]) => this.bar.classList.toggle('away', e.isIntersecting)).observe(foot);
      }
    }
    update() {
      const v = this.data.variants.find(x => x.options.every((o, i) => o === this.selected[i]));
      $$('[data-option]', this).forEach(b => b.setAttribute('aria-pressed', this.selected[Number(b.dataset.index)] === b.dataset.option));
      const add = $('[data-add]', this);
      if (!v) { if (add) { add.disabled = true; $('span', add).textContent = this.data.strings.unavailable; } return; }
      $$('input[name="id"]', this).forEach(i => { i.value = v.id; });
      $$('[data-price]', this).forEach(p => { p.textContent = money(v.price); });
      $$('[data-compare]', this).forEach(p => { p.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; p.hidden = !(v.compare_at_price > v.price); });
      $$('[data-variant-title]', this).forEach(p => { p.textContent = v.title === 'Default Title' ? '' : v.title; });
      if (add) { add.disabled = !v.available; $('span', add).textContent = v.available ? T.strings.addToCart : T.strings.soldOut; }
      if (v.image) { const img = $('.pp-hero__stage img', this); if (img) { img.removeAttribute('srcset'); img.src = sz(v.image, 1600); } }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
  }
  customElements.define('product-page', ProductPage);

  /* ---------- Kollektion: Sortieren, Filter, Mehr laden ---------- */
  class CollectionGrid extends HTMLElement {
    connectedCallback() {
      $('[data-sort]', this)?.addEventListener('change', e => { const url = new URL(location.href); url.searchParams.set('sort_by', e.target.value); url.searchParams.delete('page'); location.href = url; });
      $$('.filters details', this).forEach(d => d.addEventListener('toggle', () => { if (d.open) $$('.filters details', this).forEach(o => { if (o !== d) o.open = false; }); }));
      document.addEventListener('click', e => { if (!e.target.closest('.filters details')) $$('.filters details[open]', this).forEach(d => { d.open = false; }); });
      this.addEventListener('click', async e => {
        const more = e.target.closest('[data-more]'); if (!more) return;
        e.preventDefault(); more.classList.add('is-busy'); more.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(more.href); url.searchParams.set('section_id', this.dataset.section);
          const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
          const grid = $('.grid', this), cards = $$('.grid > *', doc);
          cards.forEach((c, i) => { c.setAttribute('data-reveal', ''); c.style.setProperty('--d', i % 4); grid.append(c); });
          reveal(grid);
          const loaded = new URL(more.href); loaded.searchParams.delete('section_id');
          const next = $('[data-more]', doc);
          if (next) more.href = next.getAttribute('href'); else more.closest('.coll-more')?.remove();
          history.replaceState(null, '', loaded);
        } catch (err) { location.href = more.href; }
        more.classList.remove('is-busy'); more.removeAttribute('aria-busy');
      });
    }
  }
  customElements.define('collection-grid', CollectionGrid);

  /* ---------- Linien-Szenen (Kollektion): spielen einmal von selbst ab, Maus drüber spielt erneut ---------- */
  const seg = (p, a, b) => clamp((p - a) / (b - a));
  const ease = easeIO;
  const fall = t => t * t; // Fallen wie mit Schwerkraft
  const tf = (el, v) => el && el.setAttribute('transform', v);
  const op = (el, v) => { if (el) el.style.opacity = v; };
  const SCENES = {
    // Flasche öffnet sich und gießt in die Tasse, danach Dampf
    pour(e, p) {
      const off = ease(seg(p, 0, .15)) - ease(seg(p, .86, .98));
      const wiggle = Math.sin(seg(p, 0, .07) * Math.PI * 4) * 5 * (1 - seg(p, .05, .08));
      tf(e.cap, `translate(${(40 * off).toFixed(1)} ${(-130 * off).toFixed(1)}) rotate(${(-18 * off + wiggle).toFixed(2)} 920 120)`);
      const tilt = ease(seg(p, .12, .35)) - ease(seg(p, .76, .92));
      tf(e.bottle, `rotate(${(-115 * tilt).toFixed(2)} 861.5 460.9)`);
      const lv = ease(seg(p, .38, .75)), ly = 925 - 220 * lv;
      tf(e.level, `translate(0 ${ly.toFixed(1)})`); op(e.level, lv > .004 ? 1 : 0);
      const grow = seg(p, .33, .42), end = seg(p, .7, .78), top = 590;
      e.stream.setAttribute('y1', (top + (ly - top) * end).toFixed(1));
      e.stream.setAttribute('y2', (top + (ly - top) * grow).toFixed(1));
      op(e.stream, grow > 0 && end < 1 ? 1 : 0);
      e.steam.forEach((s, i) => { s.style.strokeDashoffset = (1 - ease(seg(p, .86 + i * .03, .97 + i * .01))).toFixed(3); });
      e.host.classList.toggle('is-steaming', p > .97);
    },
    // Klickverschlüsse auf, Deckel klappt weg, Brot und Apfel fallen hinein, Deckel zu, Klick
    lunch(e, p) {
      const clip = ease(seg(p, 0, .14)) - ease(seg(p, .84, .95));
      tf(e.clipL, `rotate(${(-120 * clip).toFixed(2)} 318 672)`);
      tf(e.clipR, `rotate(${(120 * clip).toFixed(2)} 882 672)`);
      const lid = ease(seg(p, .12, .34)) - ease(seg(p, .66, .86));
      tf(e.lid, `rotate(${(100 * lid).toFixed(2)} 878 640)`);
      const bread = seg(p, .32, .5), apple = seg(p, .46, .64);
      tf(e.bread, `translate(0 ${(-520 * (1 - fall(bread))).toFixed(1)})`); op(e.bread, bread > 0 ? Math.min(1, bread * 6) : 0);
      tf(e.apple, `translate(0 ${(-560 * (1 - fall(apple))).toFixed(1)})`); op(e.apple, apple > 0 ? Math.min(1, apple * 6) : 0);
      op(e.marks, seg(p, .93, .97));
    },
    // Teller fällt, saugt sich fest (Plopp), wackelt, bleibt stehen; Erbsen fallen darauf
    plate(e, p) {
      const drop = seg(p, 0, .28), land = seg(p, .28, .4), wob = seg(p, .38, .64);
      const y = -150 * (1 - fall(drop));
      const squash = 1 - .1 * Math.sin(land * Math.PI);
      const ang = Math.sin(wob * Math.PI * 5) * 7 * (1 - wob);
      tf(e.plate, `translate(0 ${y.toFixed(1)}) rotate(${ang.toFixed(2)} 600 925) translate(600 925) scale(1 ${squash.toFixed(3)}) translate(-600 -925)`);
      op(e.plopp, seg(p, .28, .32) * (1 - seg(p, .5, .6)));
      e.peas.forEach((c, i) => {
        const t = seg(p, .6 + i * .06, .76 + i * .06);
        const bounce = t > .85 ? Math.sin((t - .85) / .15 * Math.PI) * 14 : 0;
        c.setAttribute('transform', `translate(${((1 - t) * (i - 2) * 18).toFixed(1)} ${(-330 * (1 - fall(Math.min(1, t / .85))) - bounce).toFixed(1)})`);
        op(c, t > 0 ? 1 : 0);
      });
    },
    // Deckel ab, Pinsel fährt in die Flasche und schrubbt, Seifenblasen steigen, Pinsel raus, Deckel drauf, sauber
    brush(e, p) {
      const off = ease(seg(p, 0, .12)) - ease(seg(p, .88, .98));
      tf(e.cap, `translate(${(150 * off).toFixed(1)} ${(-40 * off).toFixed(1)}) rotate(${(22 * off).toFixed(2)} 500 120)`);
      const down = ease(seg(p, .12, .4)), up = ease(seg(p, .75, .9)), scrub = seg(p, .4, .75);
      const y = -1150 * (1 - down) - 1150 * up - 90 * (.5 - .5 * Math.cos(scrub * Math.PI * 4));
      tf(e.brush, `translate(0 ${y.toFixed(1)})`);
      op(e.brush, Math.min(seg(p, .12, .18), 1 - seg(p, .85, .9)));
      const ph = p * 60;
      e.bristles.forEach((l, i) => {
        const taper = Math.sin(((i + .5) / e.bristles.length) * Math.PI) * .35 + .65;
        const a = 70 * taper * (.78 + .22 * Math.sin(ph + i * .9)), b = 70 * taper * (.78 + .22 * Math.sin(ph + i * .9 + Math.PI));
        l.setAttribute('x1', (500 - a).toFixed(1)); l.setAttribute('x2', (500 + b).toFixed(1));
      });
      e.bubbles.forEach((c, i) => {
        const t = seg(p, .45 + i * .045, .8 + i * .025);
        c.setAttribute('cy', (165 - 300 * t).toFixed(1));
        c.setAttribute('cx', (500 + (i - 2.5) * 22 + Math.sin(t * 6 + i) * 14).toFixed(1));
        c.setAttribute('r', (7 + 11 * t + (i % 2) * 4).toFixed(1));
        op(c, t > 0 && t < 1 ? Math.min(1, t * 8, (1 - t) * 4) : 0);
      });
      op(e.sparkle, seg(p, .92, 1));
    }
  };
  class LineScene extends HTMLElement {
    connectedCallback() {
      this.fn = SCENES[this.dataset.scene]; if (!this.fn || !$('svg', this)) return;
      const els = { host: this, steam: $$('.ls__steam path', this), peas: $$('[data-el="peas"] circle', this), bristles: $$('[data-el="bristles"] line', this), bubbles: $$('[data-el="bubbles"] circle', this) };
      $$('[data-el]', this).forEach(el => { if (!els[el.dataset.el]) els[el.dataset.el] = el; });
      this.els = els;
      if (!anim) { this.fn(els, 1); return; }
      this.fn(els, 0);
      // Läuft von selbst, sobald die Zeichnung zu sehen ist (nach dem Zeichnen der Linien), einmal.
      // Maus drüber oder Antippen spielt sie noch einmal. Scrollen spielt keine Rolle.
      let started = false;
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting || started) return;
        started = true; io.disconnect(); setTimeout(() => this.play(), 600);
      }, { threshold: .6 });
      io.observe(this);
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse' && started) this.play(); });
      this.addEventListener('click', () => { if (started) this.play(); });
    }
    play() {
      if (this.raf) return;
      const dur = 4200, t0 = performance.now();
      const tick = now => {
        const p = clamp((now - t0) / dur);
        this.fn(this.els, p);
        this.raf = p < 1 ? requestAnimationFrame(tick) : null;
      };
      this.raf = requestAnimationFrame(tick);
    }
    render(p) { this.fn(this.els, p); }
  }
  customElements.define('line-scene', LineScene);

  /* ---------- Passende Produkte (nachladen) ---------- */
  class ProductRecs extends HTMLElement {
    connectedCallback() {
      if (this.children.length || !this.dataset.url) return;
      const load = async () => {
        try {
          const doc = new DOMParser().parseFromString(await (await fetch(this.dataset.url)).text(), 'text/html');
          const fresh = $('product-recs', doc);
          if (fresh && fresh.children.length) { this.innerHTML = fresh.innerHTML; reveal(this); }
          else this.closest('.shopify-section')?.remove();
        } catch (e) { /* ohne Empfehlungen weiter */ }
      };
      if (!('IntersectionObserver' in window)) return load();
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 600px 0px' });
      io.observe(this);
    }
  }
  customElements.define('product-recs', ProductRecs);

  /* ---------- Länderauswahl in Adressen ---------- */
  $$('select[data-default]').forEach(sel => { if (sel.dataset.default) sel.value = sel.dataset.default; });
})();
